import React, {useCallback, useContext, useEffect, useState} from "react";
import {DataGridPro, useGridApiRef} from "@mui/x-data-grid-pro";
import PageContextZiggy from "../../store/page-context-ziggy";
import {Button, Chip, Paper, Stack} from "@mui/material";
import axios from "axios";
import {PageContext, toast, useStickyState} from "@lb/mlib-components";
import {convertTS, convertTSDayFirst, getMomentDate, simpleConvertTS} from "../../utils/getMomentDate";
import getWeights from "../../utils/getWeights";
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {getMomentDateFromString} from "../../utils/getMomentDateFromString";
import CheckIcon from "@mui/icons-material/Check";
import {titleCase} from "../../utils/titleCase";
import {largeNumberFormattedDollar} from "../../utils/largeNumberFormatted";
import EditIcon from "@mui/icons-material/Edit";
import {renderEdit, validatePriority} from "../shipments/columns";
import {dataGridProStateVersion} from "../../App";

export default function PersistDataGridPro(props) {

    const pageCtxZiggy = useContext(PageContextZiggy);
    const pageCtx = useContext(PageContext);

    const pageTitle = pageCtx.title;

    let backgroundColor;

    if (pageTitle === "Today") {
        backgroundColor = "#f09666";
    } else if (pageTitle === "In Transit") {
        backgroundColor = "#66a5d0";
    } else if (pageTitle === "Future") {
        backgroundColor = "#97cb72";
    }

    const [rows, setRows] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [searched, setSearched] = useState("");

    const [loading, setLoading] = useState(false);

    let defaultPageSize = 10;

    const [dataGridProStateVersionStickyState, setDataGridProStateVersionStickyState] =
        useStickyState(dataGridProStateVersion, 'dataGridProStateVersion');

    if (pageTitle === "Today" || pageTitle === "In Transit" || pageTitle === "Future") {
        defaultPageSize = props?.pageSize || defaultPageSize;
    }

    const [sortModel, setSortModel] = useStickyState([], props.view + "SortModelPersistDataGridPro");
    const [columns, setColumns] = useStickyStateForColumns(props.columns, props.view + "ColumnsPersistDataGridPro");
    const [columnsOriginal, setColumnsOriginal] = useStickyStateForColumns(props.columns, props.view + "ColumnsOriginalPersistDataGridPro");
    const [columnVisibilityModel, setColumnVisibilityModel] = useStickyState(props.columnVisibilityModel || {}, props.view + "VisibilityModelPersistDataGridPro");
    const [columnVisibilityModelOriginal, setColumnVisibilityModelOriginal] = useStickyState(props.columnVisibilityModel || {}, props.view + "VisibilityModelOriginalPersistDataGridPro");

    const [columnsState, setColumnsState] = useStickyState({
        pagination: {
            paginationModel: {pageSize: defaultPageSize, page: 0},
        },
    }, props.view + "ColumnsStatePersistDataGridPro");

    const apiRef = useGridApiRef();

    function useStickyStateForColumns(defaultValue, key) {

        const [value, setValue] = useState(() => {
            let stickyValue = window.localStorage.getItem(key);

            if (stickyValue !== null) {
                let stickyValueJSON = JSON.parse(stickyValue);

                for (let i = 0; i < stickyValueJSON.length; i++) {

                    let column = stickyValueJSON[i]

                    // Define the array of fields
                    const getMomentDateFields = [
                        "created",
                        "epoc_picked",
                        "epoc_requested",
                        "epoc_created",
                        "epoc_pickupest",
                        "epoc_pickup",
                        "pickup",
                        "epoc_requested",
                        "startdate",
                        "enddate",
                        "deliverydate",
                        "shipmentdate",
                        "epoc_packby",
                        "packed",
                        "packby",
                        "estpickup",
                        "shipped",
                        "delivered",
                        "estdelivered",
                        "not_before",
                        "approved",
                        "modified_ts",
                        'start_datetime',
                        'end_datetime'

                    ];

                    const getMomentDateFromStringFields = ["target_arrival", "effective_str", "holiday"];
                    const largeNumberFormattedDollarFields = ["totalcad", "daily_dollar"];
                    const titleCaseFields = ["status"];
                    const convertTSFields = ["epoc_packed", "epoc_shipped", "epoc_pickedup",
                        "epoc_deliveryest",
                        "epoc_delivered"];
                    const convertSimpleTSFields = ["posted_ts"];
                    const convertTSDayFirstFields = ["created"];

                    if (getMomentDateFromStringFields.includes(column.field)) {
                        column = {
                            ...column,
                            valueFormatter: getMomentDateFromString
                        };
                    }
                    if (convertSimpleTSFields.includes(column.field)) {
                        column = {
                            ...column,
                            valueFormatter: simpleConvertTS
                        };
                    }
                    if (getMomentDateFields.includes(column.field)) {
                        column = {
                            ...column,
                            valueFormatter: getMomentDate
                        };
                    } else if (largeNumberFormattedDollarFields.includes(column.field)) {
                        column = {
                            ...column,
                            valueFormatter: largeNumberFormattedDollar
                        };
                    } else if (titleCaseFields.includes(column.field)) {
                        column = {
                            ...column,
                            valueFormatter: titleCase
                        };
                    } else if (convertTSFields.includes(column.field)) {
                        column = {
                            ...column,
                            valueFormatter: convertTS
                        };
                    } else if (convertTSDayFirstFields.includes(column.field)) {
                        column = {
                            ...column,
                            valueFormatter: convertTSDayFirst
                        };
                    } else if (column.field === "clone") {
                        column = {
                            ...column,
                            renderCell: ({row}) => (
                                <Button onClick={() => props.clone(row)}>
                                    Clone
                                </Button>
                            )
                        };
                    } else if (column.field === "selected_servicename") {
                        column = {
                            ...column,
                            valueGetter: ({row}) => `${row.selected.servicename}`
                        };
                    } else if (column.field === "selected_price") {
                        column = {
                            ...column,
                            valueGetter: ({row}) => `${row.selected.total} ${row.selected.currency}`
                        };
                    } else if (column.field === "weightkg") {
                        column = {
                            ...column,
                            renderCell: getWeights
                        };
                    } else if (column.field === "completion_status") {
                        column = {
                            ...column,
                            renderCell: (params) => (
                                <Box padding={2}>
                                    {params.value === 10 && <CheckIcon color={'success'}/>}
                                    {params.value === 99 && <CloseIcon color="error"/>}
                                    {params.value > 0 && params.value < 7 &&
                                        <Typography>Attempts: {params.value - 1}</Typography>}
                                </Box>
                            )
                        };
                    } else if (column.field === "issuance_percent") {
                        column = {
                            ...column,
                            valueGetter: ({row}) => `${row.issuance_percent}%`
                        };
                    } else if (column.field === "pack_percentage") {
                        column = {
                            ...column,
                            valueGetter: ({row}) => `${row.pack_percentage}%`
                        };
                    } else if (column.field === "salesorderid") {
                        column = {
                            ...column,
                            renderCell: (params) => (
                                <Stack direction={"row"} spacing={1} alignItems={'center'}>
                                    <Typography variant={"body2"}>
                                        {params.row.salesorderid}
                                    </Typography>
                                    {params.row.fedex && (
                                        [2].includes(params.row.fedexstatus) ?
                                            <Chip label="FedEx Hold" size={'small'}/> :
                                            <img
                                                width={50}
                                                height={'100%'}
                                                src={`https://content.longboardproducts.com/logo/fedex${params.row.courier_brand === 'fedex_manual' ? '_manual' : ''}.png`}
                                                alt={'fedex'}
                                            />
                                    )}
                                    {params.row.hold_prod && <Chip label={'On Hold'} size={'small'}/>}

                                </Stack>
                            )
                        };

                    } else if (column.field === "priority") {
                        column = {
                            ...column,
                            preProcessEditCellProps: (params) => {
                                const errorMessage = validatePriority(+params.props.value);
                                return {...params.props, error: errorMessage};
                            },
                            renderEditCell: renderEdit,
                            renderCell: (params) => (
                                <Stack direction={"row-reverse"} alignItems={"center"}>
                                    <IconButton sx={{color: '#afaeae'}} size={"small"}><EditIcon
                                        fontSize='inherit'/></IconButton>
                                    <Typography variant={"body2"}>{params.row.priority}</Typography>
                                </Stack>),
                        };

                    } else if (column.field === "note" && pageTitle === 'Production | Reconcile') {
                        column = {
                            ...column,
                            renderCell: (params) => (
                                <Stack direction={"row-reverse"} alignItems={"center"}>
                                    <IconButton sx={{color: '#afaeae'}} size={"small"}><EditIcon
                                        fontSize='inherit'/></IconButton>
                                    <Typography variant={"body2"}>{params.row.note}</Typography>
                                </Stack>),
                        };

                    } else if (column.field === "countries") {
                        column = {
                            ...column,
                            renderCell: (params) => (
                                <Box sx={{display: "flex", flexWrap: "wrap"}}>
                                    {params.row.countries?.map((item) => (
                                        <div style={{margin: "1px"}} key={item}>
                                            <Chip label={item} size={"small"}/>
                                        </div>
                                    ))}
                                </Box>),
                        };

                    }

                    let newList = stickyValueJSON.filter(item => item.field !== column.field);
                    stickyValueJSON = addAfter(newList, i, column);

                }

                return stickyValueJSON;
            } else {
                return defaultValue;
            }

        });
        useEffect(() => {
            window.localStorage.setItem(key, JSON.stringify(value));
        }, [key, value]);

        return [value, setValue];
    }

    const resetAll = useCallback(() => {
        setColumns(props.columns)
        setColumnsOriginal(props.columns)
        setColumnsState({
            pinnedColumns: {},
            pagination: {
                paginationModel: {
                    pageSize: defaultPageSize, page: 0
                },
            },
        })
        setColumnVisibilityModel(props.columnVisibilityModel || {})
        setColumnVisibilityModelOriginal(props.columnVisibilityModel || {})

        setSortModel([])
        setDataGridProStateVersionStickyState(dataGridProStateVersion);

    }, [defaultPageSize, props.columnVisibilityModel, props.columns, setColumnVisibilityModel, setColumnVisibilityModelOriginal, setColumns, setColumnsOriginal, setColumnsState, setDataGridProStateVersionStickyState, setSortModel]);


    useEffect(() => {
        if (dataGridProStateVersion !== dataGridProStateVersionStickyState)
            resetAll()

        if (JSON.stringify(props.columnVisibilityModel || {}) !== JSON.stringify(columnVisibilityModelOriginal || {}))
            resetAll()

        for (const key in props.columns) {
            if (columnsOriginal[key]?.headerName !== props.columns[key].headerName) {
                resetAll()
            }
            if (columnsOriginal[key]?.field !== props.columns[key].field) {
                resetAll()

            }

            if (columnsOriginal[key]?.type !== props.columns[key].type) {
                resetAll()

            }
            if (columnsOriginal[key]?.flex === 1) {
                resetAll()

            }
            if (columnsOriginal.length !== props.columns.length) {
                resetAll()

            }
            if (columnsOriginal[key]?.width !== props.columns[key].width) {
                resetAll()

            }
        }


    }, []);

    React.useEffect(() => {

        setLoading(true);

        let finalApiUrl = '/' + props.view.split("?")[0];

        let apiPage = columnsState?.pagination?.paginationModel?.page + 1;

        finalApiUrl += `?page=${apiPage}&pagesize=${columnsState?.pagination?.paginationModel?.pageSize}`;

        if (searched.length > 0) {
            finalApiUrl += `&filter=${searched}`;
        }
        if (props.search !== undefined && props.search) {
            finalApiUrl += `&filter=${props.search}`;
        }

        if (sortModel.length > 0) {
            if (sortModel[0].sort === "asc") finalApiUrl += `&sort=${sortModel[0].field}`; else finalApiUrl += `&sort=-${sortModel[0].field}`;
        }

        if (pageTitle === "Today" || pageTitle === "In Transit" || pageTitle === "Future") {
            finalApiUrl += `&${props.view.split("?")[1]}`;
        }

        if (pageTitle === "Shipping | Prepare" || pageTitle === "Shipping | Fulfilment" || pageTitle === "Shipping | Scheduler" || pageTitle === "Shipping | Prepare" || pageTitle === "Production | Orders") {
            if (props.warehouse !== undefined && props.warehouse !== 'All')
                finalApiUrl += `&warehouse=${props.warehouse}`;
        }

        if (props.state !== undefined && props.state !== 'All') {
            finalApiUrl += `&active=${props.state === 'active'}`;
        }

        if (props.reviewed !== undefined && props.reviewed !== 'All') {
            finalApiUrl += `&reviewed=${props.reviewed === 'reviewed'}`;
        }


        if (props.status !== undefined && props.status !== 'All') {
            if (props.status === 'manualship')
                finalApiUrl += `&status=notshown`;
            else
                finalApiUrl += `&status=${props.status}`;
        }

        if (props.lbship !== undefined && props.lbship !== 'All') {
            if (props.lbship === 'LB Ship' || props.lbship === 'Not LB Ship')
                finalApiUrl += `&lbship=${props.lbship === 'LB Ship'}`;
        }

        if (props.warehouse !== undefined && props.warehouse !== 'All') {
            finalApiUrl += `&warehouse=${props.warehouse}`;
        }

        if (props.queue_status !== undefined && props.queue_status !== 'all') {
            finalApiUrl += `&queue_status=${props.queue_status}`;
        }

        if (pageTitle === "Shipping | Scheduler" && props.dnnFilter !== 'All') {
            finalApiUrl += `&ddn_filter=${props.dnnFilter?.toLowerCase()}`;
        }
        if (pageTitle === "Shipping | Fulfilment" && props.finish !== 'All') {
            finalApiUrl += `&finish=${props.finish?.toLowerCase()}`;
        }

        if (props.workcenter && props.workcenter.length > 0 && props.workcenter !== 'All') finalApiUrl += `&workcentre=${props.workcenter.toUpperCase()}`;

        axios.get(finalApiUrl).then((response) => {

            const newRows = response.data.items.map((e, index) => ({id: index.toString(), ...e}))
            setRows(newRows);
            if (props.setRows !== undefined)
                props.setRows(newRows)
            setRowCount(response.data.total);
        }).finally(() => {

            setLoading(false);
        });


    }, [props.reviewed, props.generalLoad, columnsState?.pagination?.paginationModel?.page, columnsState?.pagination?.paginationModel?.pageSize, sortModel, props.load, searched, props.dnnFilter, props.view, props.state, props.warehouse, props.workcenter, props.finish, props.status, props.lbship, props.search, pageTitle, props.items, props.setRows, props]);


    function addAfter(array, index, newItem) {
        return [...array.slice(0, index), newItem, ...array.slice(index)];
    }

    useEffect(() => {
        return apiRef.current.subscribeEvent('columnOrderChange', (params) => {
            const item = columns[params.oldIndex];
            let newList = columns.filter(item => item.field !== params.colDef.field)
            setColumns(addAfter(newList, params.targetIndex, item));
        });
    }, [apiRef, columns, setColumns]);

    useEffect(() => {
        return apiRef.current.subscribeEvent('columnWidthChange', (params) => {

            for (let i = 0; i < columns.length; i++) {
                if (columns[i].field === params.colDef.field) {
                    const column = columns[i];
                    column.width = params.colDef.width;
                    let newList = columns.filter(item => item.field !== params.colDef.field)
                    setColumns(addAfter(newList, i, column));
                }
            }

        });
    }, [apiRef, columns, setColumns]);


    useEffect(() => {
        return apiRef.current.subscribeEvent('stateChange', (params) => {

            const setColumnsStateFinal = props.setColumnsState !== undefined ? props.setColumnsState : setColumnsState

            setColumnsStateFinal({
                pinnedColumns: params?.pinnedColumns, pagination: {
                    paginationModel: {
                        pageSize: params?.pagination?.paginationModel?.pageSize,
                        page: params?.pagination?.paginationModel?.page
                    },
                },
            })

        });
    }, [apiRef, columns, props, setColumns, setColumnsState]);


    const handleSortModelChange = (newModel) => {
        setSortModel(newModel);
    };

    const {timer} = window['runConfig'];


    useEffect(() => {
        if (pageCtxZiggy.playing && (pageTitle === "Today" || pageTitle === "In Transit" || pageTitle === "Future" || pageTitle === "Map")) {
            let timeoutID;

            const secondsPerRow = 2;

            let rowsTime = secondsPerRow * props.rowCount * 1000;

            let finalTimer = timer;

            if (finalTimer < rowsTime) {
                finalTimer = rowsTime;
            }

            timeoutID = setTimeout(() => {
                let nextPage = columnsState.pagination.paginationModel.page + 1;
                setColumnsState((prevState) => ({
                    pinnedColumns: prevState.pinnedColumns, pagination: {
                        paginationModel: {
                            pageSize: prevState?.pagination?.paginationModel?.pageSize,
                            page: nextPage
                        },
                    },
                }))
            }, finalTimer);

            return () => clearTimeout(timeoutID);
        }
    }, [pageCtx, columnsState?.pagination?.paginationModel?.page, pageTitle, props.rowCount, timer, setColumnsState]);


    const requestSearch = (searchedVal) => {
        setSearched(searchedVal);
    };

    const cancelSearch = () => {
        setSearched("");
    };

    const handleCellEditCommit = useCallback(
        (row) =>
            new Promise((resolve, reject) => {
                setTimeout(() => {

                    if (pageTitle !== 'Production | Reconcile') {

                        axios.put('/' + props.view + '/' + rows.find((e) => e.id === row.id)?.shipmentid,
                            {
                                priority: row.priority
                            }).then((res) => {
                            resolve({...row, priority: row.priority});

                            //props.loadShipmentDetailsFromServer();
                            //toast.success('Your request has been successfully sent.');

                        })
                    } else {

                        axios.post('/reconcile',
                            {
                                inventoryid: rows.find((e) => e.id === row.id)?.id,
                                note: row.note
                            }).then((res) => {
                            resolve({...row, note: row.note});

                            //props.loadShipmentDetailsFromServer();
                            //toast.success('Your request has been successfully sent.');

                        })
                    }
                }, 200);
            }),
        [pageTitle, props.view, rows],
    );

    const processRowUpdate = useCallback(
        async (newRow, oldRow) => {
            // Make the HTTP request to save in the backend

            const response = await handleCellEditCommit(newRow);

            return response;
        },
        [handleCellEditCommit],
    );

    const handleProcessRowUpdateError = React.useCallback((error) => {
        toast.error('There was an error processing your request.')
    }, []);


    const handleCellClick = (param, event) => {
        if (param.field === "priority" || (param.field === "note" && pageTitle === 'Production | Reconcile')) {
            event.ignore = true;
        }
    };

    let content;


    if (pageTitle === "Today" || pageTitle === "In Transit" || pageTitle === "Future") {
        content = <Box style={{height: '81vh', width: '100%'}} sx={[{
            '& .super-app-theme': {
                fontSize: "200%"
            }, '& .super-app-theme-header': {
                fontSize: "200%", backgroundColor: backgroundColor,
            },
        }]}>
            <DataGridPro
                apiRef={apiRef}
                rows={rows}
                columns={columns}
                getRowClassName={(params) => `super-app-theme`}
                disableRowSelectionOnClick
                pageSizeOptions={[10, 25, 50, 100]}
                rowCount={rowCount}
                pagination
                paginationMode="server"
                sortingMode="server"
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
                hideFooterPagination
                disableColumnFilter
                loading={loading}
                rowHeight={90}
                autoHeight

            />
        </Box>
    } else {
        content = <Box sx={{
            '& .super-app-theme--cell': {
                backgroundColor: 'rgba(253,231,170,0.55)',
                color: '#000000',
            },
        }}>
            <DataGridPro
                apiRef={apiRef}
                rows={rows}
                columns={columns}
                pageSizeOptions={[10, 25, 50, 100]}
                rowCount={rowCount}
                pagination
                paginationMode="server"
                sortingMode="server"
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
                hideFooterSelectedRowCount
                onRowClick={props.handleRowClick}
                disableRowSelectionOnClick
                disableColumnFilter
                loading={loading}
                autoHeight={!props.noAutoHeight}
                processRowUpdate={processRowUpdate}
                onProcessRowUpdateError={handleProcessRowUpdateError}
                onCellClick={handleCellClick}
                columnVisibilityModel={columnVisibilityModel}
                onColumnVisibilityModelChange={(newModel) =>
                    setColumnVisibilityModel(newModel)
                }
                initialState={columnsState}
                checkboxSelection={props.checkboxSelection || false}
                onRowSelectionModelChange={props.onSelectionModelChange}
                rowSelectionModel={props.selectionModel}
                isRowSelectable={props.isRowSelectable || true}
            />
            <Stack direction={"row"} justifyContent={"flex-start"}>
                <Button onClick={resetAll} color="error">Reset columns</Button>
            </Stack>
        </Box>
    }

    return <Stack direction={"column"}>

        {(pageTitle !== "Today" && pageTitle !== "In Transit" && pageTitle !== "Future" && pageTitle !== "Map") &&
            <Grid container spacing={1} direction="row"
                  justifyContent="space-between"
                  alignItems="center">

                {props.search === undefined && <Grid item xs={props.searchWidth || 12}>
                    <Paper variant="outlined">
                        <Box
                            component="form"
                            variant="outlined"
                            sx={{
                                p: "2px 2px",
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                            }}
                        >
                            <InputBase
                                size={"small"}
                                sx={{ml: 1, flex: 1}}
                                value={searched}
                                placeholder="Search"
                                onChange={(event) => requestSearch(event.target.value)}
                                onKeyPress={(event) => {
                                    if (event.key === "Enter") {
                                        requestSearch(event.target.value);
                                        event.preventDefault();
                                    }
                                }}
                            />
                            <IconButton
                                sx={{p: "10px"}}
                                aria-label="close"
                                onClick={cancelSearch}
                            >
                                <CloseIcon/>
                            </IconButton>
                        </Box>
                    </Paper>
                </Grid>}

                {props.children}

            </Grid>}
        <Box margin={0.5}></Box>
        {content}
    </Stack>;

}

